"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ws_base_1 = __importDefault(require("./ws.base"));
var ws_retry_1 = __importDefault(require("./ws.retry"));
var createSmartagentChatWebsocket = function (options) { return __awaiter(void 0, void 0, void 0, function () {
    var ws, updateContact, getContactAttributes, describeContactEvent, getChatSession, startChatSession, postConnectionToken, putChatMessage, putChatEvent, toggleAutoTranslate, getAttachment, close, addMessageListener, removerMessageListener;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, (0, ws_base_1.default)(options)];
            case 1:
                ws = _a.sent();
                updateContact = function (data) { return __awaiter(void 0, void 0, void 0, function () {
                    var e_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                return [4, ws.send({
                                        eventType: 'UpdateContact',
                                        data: data,
                                    })];
                            case 1:
                                _a.sent();
                                return [3, 3];
                            case 2:
                                e_1 = _a.sent();
                                console.log('unable to update contact');
                                console.error(e_1);
                                return [3, 3];
                            case 3: return [2];
                        }
                    });
                }); };
                getContactAttributes = function (data) { return __awaiter(void 0, void 0, void 0, function () {
                    var response;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4, ws.send({
                                    eventType: 'GetContactAttributes',
                                    data: data,
                                })];
                            case 1:
                                response = _a.sent();
                                return [2, response];
                        }
                    });
                }); };
                describeContactEvent = function (contactId) { return __awaiter(void 0, void 0, void 0, function () {
                    var response;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4, ws.send({
                                    eventType: 'DescribeContactEvent',
                                    data: {
                                        contactId: contactId,
                                    },
                                })];
                            case 1:
                                response = _a.sent();
                                return [2, response];
                        }
                    });
                }); };
                getChatSession = function (contactId, participantRole) { return __awaiter(void 0, void 0, void 0, function () {
                    var response;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4, ws.send({
                                    eventType: 'GetChatSession',
                                    data: {
                                        contactId: contactId,
                                        participantRole: participantRole,
                                    },
                                })];
                            case 1:
                                response = _a.sent();
                                return [2, response];
                        }
                    });
                }); };
                startChatSession = function (data) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        return [2, (0, ws_retry_1.default)(function () { return __awaiter(void 0, void 0, void 0, function () {
                                var response;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4, ws.send({
                                                eventType: 'StartChatSession',
                                                data: data,
                                            })];
                                        case 1:
                                            response = _a.sent();
                                            return [2, response];
                                    }
                                });
                            }); })];
                    });
                }); };
                postConnectionToken = function (data) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4, ws.send({
                                    eventType: 'PostConnectionToken',
                                    data: data,
                                })];
                            case 1:
                                _a.sent();
                                return [2];
                        }
                    });
                }); };
                putChatMessage = function (data) { return __awaiter(void 0, void 0, void 0, function () {
                    var response;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                console.log('sa-log putChatMessage == ', { data: data, ws: ws });
                                return [4, ws.send({
                                        eventType: 'PutChatMessage',
                                        data: data,
                                    })];
                            case 1:
                                response = _a.sent();
                                return [2, response];
                        }
                    });
                }); };
                putChatEvent = function (data) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4, ws.send({
                                    eventType: 'PutChatEvent',
                                    data: data,
                                })];
                            case 1:
                                _a.sent();
                                return [2];
                        }
                    });
                }); };
                toggleAutoTranslate = function (data) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4, ws.send({
                                    eventType: 'ToggleAutoTranslate',
                                    data: data,
                                })];
                            case 1:
                                _a.sent();
                                return [2];
                        }
                    });
                }); };
                getAttachment = function (data) { return __awaiter(void 0, void 0, void 0, function () {
                    var response;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4, ws.send({
                                    eventType: 'GetAttachment',
                                    data: data,
                                })];
                            case 1:
                                response = _a.sent();
                                return [2, response];
                        }
                    });
                }); };
                close = function () {
                    ws.close();
                };
                addMessageListener = function (func) {
                    ws.onMessage(func);
                };
                removerMessageListener = function (func) {
                    ws.offMessage(func);
                };
                return [2, {
                        getChatSession: getChatSession,
                        getContactAttributes: getContactAttributes,
                        startChatSession: startChatSession,
                        postConnectionToken: postConnectionToken,
                        putChatMessage: putChatMessage,
                        putChatEvent: putChatEvent,
                        addMessageListener: addMessageListener,
                        removerMessageListener: removerMessageListener,
                        close: close,
                        updateContact: updateContact,
                        toggleAutoTranslate: toggleAutoTranslate,
                        describeContactEvent: describeContactEvent,
                        getAttachment: getAttachment,
                    }];
        }
    });
}); };
exports.default = createSmartagentChatWebsocket;
